module.exports = __webpack_public_path__ + "static/img/happy_pink.be2f9e40.png";